<template>
  <div class="ps-page--signin">
    <div class="container">
      <div class="login-cart-page">
        <div class="container">
          <form @submit.prevent="submit" class="ps-form--signin">
            <loading
              :active="loading"
              :can-cancel="false"
              loader="dots"
              color="#2292ef"
              :is-full-page="true"
            ></loading>
            <div class="ps-form__header">
              <h3>{{data_.w.sign_in}}</h3>
       
              <p>{{data_.t.or_sign_in_using_your_email_address}}</p>
            </div>
            <div class="ps-form__content">
              <div class="form-group">
                <span
                  v-if="errors &&  errors.email"
                  class="text-danger validation-error-msg"
                >{{ errors.email[0] }}</span>

                <input
                  class="form-control"
                  type="text"
                  name="email"
                  id="email"
                  v-model="fields.email"
                  placeholder="Email"
                />
              </div>
              <div class="form-group">
                <span
                  v-if="errors &&  errors.password"
                  class="text-danger validation-error-msg"
                >{{ errors.password[0] }}</span>

                <input
                  class="form-control"
                  type="password"
                  name="password"
                  id="password"
                  v-model="fields.password"
                  placeholder="Password"
                />
              </div>
            </div>
            <div class="ps-form__actions">
              <div class="ps-checkbox ps-checkbox--circle">
                <input
                  class="form-control"
                  type="checkbox"
                  id="newsletter"
                  v-model="fields.remember"
                  name="remember"
                />
                <label for="newsletter">{{data_.w.remember_me}}</label>
              </div>
              <a href="/password/reset">{{data_.w.forget_password}}</a>
            </div>
            <div class="ps-form__footer">
              <button type="submit" class="ps-btn ps-btn--fullwidth ps-btn--gradient">Login</button>
              <p>
                {{data_.t.dont_have_an_account}}
                <a href="/register">{{data_.w.sign_up_now}}</a>
              </p>
            </div>
          </form>
                 <div class="ps-form__method">
           
                <a class="ps-btn ps-btn--google" href="/login/google">
                  <i class="fab fa-google-plus-g"></i> With Google +
                </a>
              </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";

export default {
  components: {
    Loading
  },
  props: ["data"],
  data() {
    return {
      loading: false,
      data_: this.data,
      errors: {},
      fields: {},
      vars: {}
    };
  },
  created() {
    // console.log(this.data_);
    let data = JSON.parse(this.data);
    this.data_ = data;
    // console.log(this.data_);
  },
  mounted() {
    // console.log(this.data_);
  },
  methods: {
    removeMessages: function() {
      this.errors = {};
    },
    submit: function() {
      this.loading = true;
      this.$Progress.start();
      // let formData = new FormData();
      // formData.append("_method", "post");
      let self = this;

      axios({
        method: "post",
        url: "/login" + "?_method=POST",
        data: self.fields
      })
        .then(function(response) {
          self.loading = false;
          self.$Progress.finish();
          location.replace(self.data_.redirect);
        })
        .catch(function(err) {
          self.loading = false;
          self.$Progress.fail();
          self.errors = err.response.data.errors;
        });
    }
  }
};
</script>
